/* ============================================================
   ooedn — theme.js
   Two behaviors:
   1. Hero ingredient-callout cycle (10 cards rotate clockwise across 4 corner slots)
   2. Sticky $0.94/day CTA — appears after the in-hero CTA scrolls out of view
   ============================================================ */

/* ------------------------------------------------------------
   1. Hero ingredient-callout cycle
   ------------------------------------------------------------
   NOTE FOR DEV: The ingredient list is hardcoded here for the rotation logic.
   If you want this editable from the Shopify theme editor, refactor to read
   from `window.__heroIngredients` which the hero section sets via Liquid blocks.
   The hardcoded list is the v1 fallback if no blocks are configured.
   ------------------------------------------------------------ */
(function () {
  const stage = document.getElementById("stage");
  if (!stage) return;

  const defaultIngredients = [
    { ingredient: "Niacinamide",     fn: "Barrier",            icon: "ic-hex"   },
    { ingredient: "Caffeine",        fn: "Stimulating",        icon: "ic-bean"  },
    { ingredient: "Resveratrol",     fn: "Antioxidant",        icon: "ic-spark" },
    { ingredient: "Melatonin",       fn: "Overnight recovery", icon: "ic-moon"  },
    { ingredient: "Hyaluronic Acid", fn: "Hydration",          icon: "ic-drop"  },
    { ingredient: "Panthenol",       fn: "Soothing",           icon: "ic-leaf"  },
    { ingredient: "Coenzyme Q10",    fn: "Cell energy",        icon: "ic-orbit" },
    { ingredient: "L-Arginine",      fn: "Microcirculation",   icon: "ic-ring"  },
    { ingredient: "Tocopherol",      fn: "Vitamin E",          icon: "ic-leaf"  },
    { ingredient: "Ferulic Acid",    fn: "UV defense",         icon: "ic-spark" },
  ];

  const ingredients = (window.__heroIngredients && window.__heroIngredients.length)
    ? window.__heroIngredients
    : defaultIngredients;

  const slotIds = ["slot-tl", "slot-tr", "slot-bl", "slot-br"];
  const slots = slotIds.map(id => document.getElementById(id));
  if (slots.some(s => !s)) return;

  /* Clockwise rotation: tl(0) → tr(1) → br(3) → bl(2) */
  const corner = [0, 1, 3, 2];

  function makeCard(globalIdx, data, total) {
    const wrap = document.createElement("div");
    wrap.className = "card large" + (globalIdx === 0 ? " active" : "");
    const padded = String(globalIdx + 1).padStart(2, "0");
    const totalPadded = String(total).padStart(2, "0");
    wrap.innerHTML = `
      <div class="row">
        <span class="icon"><svg><use href="#${data.icon}"/></svg></span>
        <span class="col">
          <span class="function">${data.fn}</span>
          <span class="ingredient">${data.ingredient}</span>
        </span>
      </div>
      <span class="index">${padded} / ${totalPadded}</span>
    `;
    return wrap;
  }

  /* Distribute ingredients clockwise: ing[i] → slot corner[i % 4]; flatOrder is the sequence. */
  const flatOrder = [];
  ingredients.forEach((ing, i) => {
    const slotIdx = corner[i % 4];
    const slotEl = slots[slotIdx];
    const cardIdx = slotEl.children.length;
    slotEl.appendChild(makeCard(i, ing, ingredients.length));
    flatOrder.push([slotIdx, cardIdx]);
  });

  /* Single-card-at-a-time cycle */
  const cardsPerSlot = slots.map(s => [...s.children]);
  cardsPerSlot.forEach(arr => arr.forEach(c => c.classList.remove("active")));

  let pos = 0;
  let prev = null;
  let timer = null;

  function showNext() {
    const [slotIdx, cardIdx] = flatOrder[pos];
    const slotEl = slots[slotIdx];
    if (prev && prev !== slotEl.children[cardIdx]) {
      prev.classList.remove("active");
      prev.classList.add("exiting");
      const exiting = prev;
      setTimeout(() => exiting.classList.remove("exiting"), 700);
    }
    cardsPerSlot.forEach(arr => arr.forEach(c => {
      if (c !== prev && c !== slotEl.children[cardIdx]) c.classList.remove("active", "exiting");
    }));
    const card = slotEl.children[cardIdx];
    card.classList.remove("exiting");
    card.classList.add("active");
    prev = card;
    pos = (pos + 1) % flatOrder.length;
  }

  function start() { stop(); showNext(); timer = setInterval(showNext, 2200); }
  function stop()  { if (timer) { clearInterval(timer); timer = null; } }

  stage.addEventListener("mouseenter", stop);
  stage.addEventListener("mouseleave", start);

  if (!matchMedia("(prefers-reduced-motion: reduce)").matches) start();
})();


/* ------------------------------------------------------------
   2a. Dynamic stock + customer-activity ticker
   ------------------------------------------------------------
   Stock % varies day-to-day (deterministic per day so the same visitor sees
   a stable number throughout a session). Customer count varies by minute and
   slowly increments to feel "live." Both can be disabled by removing the
   .stock-progress and .live-activity elements from the hero.
   ------------------------------------------------------------ */
(function () {
  const fill        = document.querySelector('.stock-progress-fill');
  const pctText     = document.querySelector('.stock-progress-pct');
  const liveStrip   = document.querySelector('.live-activity');

  /* === Daily stock — sin wave keyed to date so it shifts but feels stable === */
  if (fill && pctText) {
    const now = new Date();
    /* Seed combines day-of-year + day-of-week + month so consecutive days differ meaningfully */
    const dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
    const seed = dayOfYear + now.getDay() * 3 + now.getMonth() * 2;
    /* Sine wave gives smooth variation in the 72-94% sold range */
    const soldPct = Math.max(72, Math.min(94, Math.round(78 + Math.sin(seed * 0.41) * 13)));
    const leftPct = 100 - soldPct;
    fill.style.width = leftPct + '%';
    pctText.textContent = 'Only ' + leftPct + '% left in stock';
  }

  /* === Live customer ticker === */
  if (liveStrip) {
    const now = new Date();
    const minuteSeed = now.getHours() * 60 + now.getMinutes();
    /* Base 30-58 customers, varies by hour */
    let customers = 32 + Math.abs(Math.round(Math.sin(minuteSeed * 0.07) * 24));
    customers = Math.max(18, Math.min(72, customers));

    /* Find the text node after the dot span */
    function setCount(n) {
      const dot = liveStrip.querySelector('.dot');
      if (!dot) return;
      /* Clear existing text after the dot */
      while (dot.nextSibling) liveStrip.removeChild(dot.nextSibling);
      liveStrip.appendChild(document.createTextNode(' ' + n + ' customers ordered in the last hour'));
    }
    setCount(customers);

    /* Ticker — bump count up every 8-15s with a brief flash. Cap at +20 over baseline. */
    const max = customers + 20;
    setInterval(() => {
      if (customers >= max) return;
      if (Math.random() > 0.55) {
        customers += 1;
        setCount(customers);
        liveStrip.classList.add('ticker-bump');
        setTimeout(() => liveStrip.classList.remove('ticker-bump'), 700);
      }
    }, 9000 + Math.random() * 6000);
  }
})();


/* ------------------------------------------------------------
   2b. Sticky $0.94/day CTA — scroll-triggered visibility
   ------------------------------------------------------------
   Shows the sticky chip only AFTER the in-hero primary CTA scrolls out of view.
   Avoids overlapping the hero's own CTA on first paint.
   ------------------------------------------------------------ */
(function () {
  const cta = document.getElementById("stickyCta");
  const btn = document.querySelector(".col-copy .btn-primary");
  if (!cta || !btn) return;
  const onScroll = () => {
    const r = btn.getBoundingClientRect();
    cta.classList.toggle("visible", r.bottom < 0);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();
